import React from "react";
import { Navigate } from "react-router-dom";

export default function AdminPrivateRoute({ condition, children }) {
  if (condition === "" || condition === false) {
    return <Navigate to="/manager/login" />;
  } else {
    return children;
  }
}
